import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import useStyles from './styles'
import React, { useState, useCallback, useEffect } from 'react'
import { Autocomplete } from '@material-ui/lab'
import { useSetorService } from 'hooks/useSetorService'
import { useUsuarioService } from 'hooks/useUsuarioService'
import { SelectUsuarios } from 'components/SelectUsuarios'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'

export const FormRetornarVestigio = (props) => {
  const { form, setForm, handleChange, multiple } = props
  const { verificarPermissao, currentUser } = useAuth()
  const setorService = useSetorService()
  const usuarioService = useUsuarioService()
  const [setores, setSetores] = useState([])
  const [processandoSetores, setProcessandoSetores] = useState(false)
  const [usuarios, setUsuarios] = useState([])
  const [processandoUsuarios, setProcessandoUsuarios] = useState(false)
  const classes = useStyles()

  const fetchSetores = useCallback(async () => {
    const result = await setorService.listarSetoresAsync(setProcessandoSetores)
    setSetores(result)
  }, [])

  const fetchUsuarios = useCallback(async () => {
    const result = await usuarioService.listarUsuariosAsync(setProcessandoUsuarios)
    setUsuarios(result)
  }, [])

  useEffect(() => {
    fetchSetores()
    fetchUsuarios()
  }, [fetchSetores, fetchUsuarios])

  return (
    <Grid container className={classes.container} spacing={3}>
      <Grid item md={12} sm={12} xs={12} lg={12}>
        <Typography className={classes.gridTitle}>
          <b>FORMULÁRIO DE RETORNO DO VESTÍGIO</b>
        </Typography>
      </Grid>

      {!multiple && (
        <>
          <Grid item md={12} sm={12} xs={12} lg={12}>
            <TextField
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              label="NÚMERO DO LACRE"
              name="lacre"
              onChange={(e) => handleChange('lacre', e.target.value)}
              value={form.lacre}
            />
          </Grid>
          <Grid item container md={12} sm={12} xs={12} className={classes.fieldGroup}>
            <Grid item md={12} sm={12} xs={12}>
              <Typography variant="body2">TIPO DA EMBALAGEM</Typography>
            </Grid>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup aria-label="tipo-embalagem" name="tipoEmbalagem" value={form.tipoEmbalagem || null} onChange={(e) => handleChange('tipoEmbalagem', e.target.value)} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />

                <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
              </RadioGroup>
            </FormControl>
            {form.tipoEmbalagem === 'OUTRO' && (
              <Grid item md={12} sm={12} xs={12}>
                <TextField
                  label="OUTRO TIPO DE EMBALAGEM"
                  name="outroTipoEmbalagem"
                  variant="outlined"
                  value={form.outroTipoEmbalagem}
                  onChange={(e) => handleChange('outroTipoEmbalagem', e.target.value)}
                  disabled={form.tipoEmbalagem !== 'OUTRO'}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            )}
          </Grid>
        </>
      )}

      <Grid item md={12} sm={12} xs={12}>
        <Autocomplete
          name="setOrig"
          value={form.setOrig || null}
          noOptionsText="Sem informações"
          options={setores}
          onChange={(event, newValue) => handleChange('setOrig', newValue)}
          getOptionLabel={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.nome.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
          renderOption={(option) => `${option.nome.toUpperCase()} / ${option.divisao.sigla.toUpperCase()} / ${option.divisao.regional.nome.toUpperCase()} / ${option.divisao.regional.orgao.sigla.toUpperCase()}`}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="SETOR ORIGEM"
              placeholder="Selecionar..."
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
          )}
        />
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <SelectUsuarios usuariosExternos={form.usuOrig} setUsuariosExternos={(valor) => handleChange('usuOrig', valor)} setProcessando={setProcessandoUsuarios} label="USUÁRIO ORIGEM" isFromBanco={true} multiplo={false} />
      </Grid>
      <Grid item md={12} sm={12} xs={12}>
        <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
          <TextField
            variant="outlined"
            fullWidth
            label={`RESPONSÁVEL PELA ENTREGA - TEXTO LIVRE`}
            InputLabelProps={{
              shrink: true,
            }}
            name="usuarioOrigemInput"
            value={form.usuarioOrigemInput}
            onChange={(e) => handleChange('usuarioOrigemInput', e.target.value)}
            disabled={form.usuOrig?.nome?.toUpperCase() !== 'OUTRO'}
          />
        </FormControl>
      </Grid>
      {verificarPermissao([constants.PERMISSOES.RETORNAR_VESTIGIO_ADMINISTRADOR]) && (
        <>
          <Grid item md={12} sm={12} xs={12}>
            <SelectUsuarios usuariosExternos={form.usuDest} setUsuariosExternos={(valor) => handleChange('usuDest', valor)} setProcessando={setProcessandoUsuarios} label="USUÁRIO RESPONSÁVEL PELO RECEBIMENTO" isFromBanco={true} multiplo={false} />
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <FormControl style={{ minWidth: '100%', maxWidth: '100%' }}>
              <TextField
                variant="outlined"
                fullWidth
                label={`RESPONSÁVEL PELO RECEBIMENTO - TEXTO LIVRE`}
                InputLabelProps={{
                  shrink: true,
                }}
                name="usuarioDestinoInput"
                value={form.usuarioDestinoInput}
                onChange={(e) => handleChange('usuarioDestinoInput', e.target.value)}
                disabled={form.usuDest?.nome?.toUpperCase() !== 'OUTRO'}
              />
            </FormControl>
          </Grid>
        </>
      )}
      <Grid item md={12} sm={12} xs={12}>
        <Autocomplete
          name="setDest"
          disabled={verificarPermissao([constants.PERMISSOES.RETORNAR_VESTIGIO_ADMINISTRADOR]) && !form.usuDest}
          value={form.setDest || null}
          noOptionsText="Sem informações"
          options={verificarPermissao([constants.PERMISSOES.RETORNAR_VESTIGIO_ADMINISTRADOR]) ? form.usuDest?.setores || [] : currentUser?.setores || []}
          onChange={(event, newValue) => handleChange('setDest', newValue)}
          getOptionLabel={(option) => `${option.nome?.toUpperCase()} / ${option.divisao?.sigla?.toUpperCase()} / ${option?.divisao?.regional?.nome.toUpperCase()} / ${option?.divisao?.regional?.orgao?.sigla?.toUpperCase()}`}
          renderOption={(option) => `${option.nome?.toUpperCase()} / ${option.divisao?.sigla?.toUpperCase()} / ${option?.divisao?.regional?.nome.toUpperCase()} / ${option?.divisao?.regional?.orgao?.sigla?.toUpperCase()}`}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="SETOR DE RETORNO DO VESTÍGIO"
              placeholder="Selecionar..."
              InputLabelProps={{
                shrink: true,
              }}
              required
            />
          )}
        />
      </Grid>
    </Grid>
  )
}
